module.exports = __webpack_public_path__ + "static/media/worker.76d634f3.svg";